<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Ustawienie stanowiska
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="workspaceId"
                            :items="workspaces"
                            :filter="customFilter"
                            label="Stanowisko"
                            class="v-text-field--placeholder-dark"
                            item-text="name"
                            item-value="id"
                            no-data-text="Brak stanowisk"
                            outlined
                            @input="onSave"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onAbort"
                >
                    Anuluj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import customFilters from '@/mixins/customFilters'
import { addSentryBreadcrumb } from '@/utils/errorHandler'

export default {
    name: 'WorkspaceSettingsDialog',
    mixins: [
        customFilters
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        workspaceIdData: {
            type: Number,
            default: null
        },
        productionProcesses: {
            type: Array,
            default: () => []
        },
        reportSettingsData: {
            type: Object,
            default: null
        },
        workspacesData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            workspaceId: null,
            settings: {
                machine: null,
                process: null,
                workspace: {}
            },
            machineProcesses: [],
            workspaces: [],
        }
    },
    computed: {
        reportSettings() {
            return this.$store.state.reports.reporting.reportSettings
        }
    },
    watch: {
        isOpen() {
            if (this.workspaceIdData) {
                this.settings = JSON.parse(JSON.stringify(this.reportSettingsData))
                this.workspaceId = JSON.parse(JSON.stringify(this.workspaceIdData))
            }
            this.workspaces = JSON.parse(JSON.stringify(this.workspacesData))
        },
    },
    methods: {
        onSave() {
            addSentryBreadcrumb('ui.action', 'Zmiana stanowiska')
            this.$emit('on-save', this.workspaceId)
        },
        onAbort() {
            setTimeout(() => {
                this.workspaceId = null,
                this.settings = {
                    machine: null,
                    process: null,
                    workspace: null
                },
                this.machineProcesses = []
                this.workspaces = []
            }, 500)

            this.$emit('on-abort')
        },
    }
}
</script>